export default __webpack_public_path__ + "static/media/arena_10.1850c7fe.jpeg";